<template>
	<!-- Team start -->
	<section class="section" id="services">
		<div class="container">
			<div class="row justify-content-center mb-5">
				<div class="col-lg-12">
					<h4 class="text-uppercasepb-1">개인통관고유부호 유효성 검증</h4>
				</div>
				<div class="col-lg-5">
					<div class="card  rounded text-center border-0 shadow overflow-hidden">
						<div class="card-body px-4 py-5">
							<h4 class="text-uppercase mb-3 pb-1">조회정보</h4>
							<div class="text-muted mb-3">오늘 조회 건수 : {{ ecmcount }} / {{ limit }}</div>
							<div class="form-check form-check-inline  mb-3">
								<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" v-model="selInput" v-on:change="changeRadio" />
								<label class="form-check-label" for="inlineRadio1">전체 입력</label>
							</div>
							<div class="form-check form-check-inline  mb-3">
								<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" v-model="selInput" v-on:change="changeRadio" />
								<label class="form-check-label" for="inlineRadio2">개별 입력</label>
							</div>
							<div id="allta" v-if="selInput === 'option1'">
								<textarea
									ref="ecmdata"
									@keydown.tab.prevent="tabber($event)"
									style="height: 200px;"
									v-model="ecmdata"
									required=""
									placeholder="이름, 개인통관고유부호, 휴대전화번호가 포함된 정보를 탭(Tab)으로 구분하여 입력해 주세요."
									type="text"
									class="form-control"
								>
								</textarea>
							</div>
							<div id="divta" class="row" v-if="selInput === 'option2'">
								<div class="col px-1">
									<div>개인통관고유부호</div>
									<textarea type="text" class="form-control divta1" v-model="ecmdata1" placeholder=""> </textarea>
								</div>
								<div class="col px-1">
									<div>이름</div>
									<textarea type="text" class="form-control divta2" v-model="ecmdata2"> </textarea>
								</div>
								<div class="col px-1">
									<div>휴대전화번호</div>
									<textarea type="text" class="form-control divta3" v-model="ecmdata3"> </textarea>
								</div>
							</div>
							<a style="margin-top: 20px;" v-on:click="ecmref" class="btn btn-primary">조회하기</a>
						</div>
					</div>
				</div>
				<div class="col-lg-7">
					<div class="card  rounded text-center border-0 shadow overflow-hidden" style="min-height:451px;">
						<div class="card-body px-4 py-5">
							<h4 class="text-uppercase mb-4 pb-1">조회결과</h4>
							<button id="exceldown" v-on:click="exceldown" type="button" class="btn btn-outline-primary btn-sm mb-2">엑셀 다운로드</button>
							<div id="divTableDataHolder" ref="divTable">
								<table class="pc4-table">
									<tr class="pc4-container">
										<th class="text-muted mb-0 pc4-title">개인통관고유부호</th>
										<th class="text-muted mb-0 pc4-title">이름A</th>
										<th class="text-muted mb-0 pc4-title"></th>
										<th class="text-muted mb-0 pc4-title">이름B</th>
										<th class="text-muted mb-0 pc4-title"></th>
										<th class="text-muted mb-0 pc4-title">번호A</th>
										<th class="text-muted mb-0 pc4-title"></th>
										<th class="text-muted mb-0 pc4-title">번호B</th>
										<th class="text-muted mb-0 pc4-title"></th>
									</tr>
									<tr v-for="item in items" :key="item.id" class="pc4-container">
										<td class="pc4-pc4">{{ item.pcccNum }}</td>
										<td v-bind:class="item.orderMemberMatch">{{ item.orderMember }}</td>
										<td v-bind:class="item.orderMemberMatch">{{ item.orderMemberOX }}</td>
										<td v-bind:class="item.receiverMatch">{{ item.receiver }}</td>
										<td v-bind:class="item.receiverMatch">{{ item.receiverOX }}</td>
										<td v-bind:class="item.phoneAMatch">{{ item.phoneA }}</td>
										<td v-bind:class="item.phoneAMatch">{{ item.phoneAOX }}</td>
										<td v-bind:class="item.phoneBMatch">{{ item.phoneB }}</td>
										<td v-bind:class="item.phoneBMatch">{{ item.phoneBOX }}</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-12">
					<div class="card rounded border-0 shadow overflow-hidden mt-5">
						<ul class="nav nav-tabs" id="myTab" role="tablist">
							<li class="nav-item" role="presentation">
								<button class="nav-link active" id="common-tab" data-bs-toggle="tab" data-bs-target="#common" type="button" role="tab" aria-controls="common" aria-selected="true">검증방법</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link" id="naver-tab" data-bs-toggle="tab" data-bs-target="#naver" type="button" role="tab" aria-controls="naver" aria-selected="false">네이버 스마트스토어</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link" id="coupang-tab" data-bs-toggle="tab" data-bs-target="#coupang" type="button" role="tab" aria-controls="coupang" aria-selected="false">쿠팡</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link" id="etc-tab" data-bs-toggle="tab" data-bs-target="#etc" type="button" role="tab" aria-controls="etc" aria-selected="false">기타 오픈마켓 및 자사몰</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link" id="membership-tab" data-bs-toggle="tab" data-bs-target="#membership" type="button" role="tab" aria-controls="membership" aria-selected="false">멤버십 안내</button>
							</li>
						</ul>
						<div class="tab-content" id="myTabContent">
							<div class="tab-pane fade show active  px-4 py-5" id="common" role="tabpanel" aria-labelledby="common-tab">
								<h4 class="text-uppercase mb-3 pb-1 ">내용 입력 양식</h4>
								<ul>
									<li class="text-muted mb-2">이름, 개인통관고유부호, 휴대전화번호를 <span style="font-weight: 900;">탭(Tab)으로 구분</span>하여 입력해주세요.</li>
									<li class="text-muted mb-2">여러 건을 조회할 경우 엔터로 구분하여 입력해주세요.</li>
									<li class="text-muted mb-5">개인통관고유부호는 P 뒤에 12자리 숫자가 있어야 정확히 인식합니다.</li>
								</ul>
								<h4 class="text-uppercase mb-3 pb-1 ">조회 결과 확인</h4>
								<ul>
									<li class="text-muted mb-2">일치 : 녹색으로 표시</li>
									<li class="text-muted mb-5">불일치 : 적색으로 표시</li>
								</ul>
								<h4 class="text-uppercase mb-3 pb-1 ">특장점</h4>
								<ul>
									<li class="text-muted mb-2">개인통관고유부호 하나에 이름, 휴대전화번호를 각각 2건씩 조회 가능합니다.</li>
									<li class="text-muted mb-2">엑셀 내용을 그대로 붙여넣기 하여 조회도 가능합니다.</li>
									<li class="text-muted mb-5">이름, 개인통관고유부호, 휴대전화번호 열 외에 다른 정보가 있어도, 해당 열을 찾아서 조회합니다.</li>
								</ul>
								<h4 class="text-uppercase mb-3 pb-1 ">더 궁금한 것이 있습니다.</h4>
								<ul>
									<li class="text-muted mb-2">네이버톡톡 또는 채널톡으로 문의해주세요.</li>
									<li class="text-muted mb-2">문의 가능 시간 : 평일 11:00~17:00</li>
								</ul>
							</div>
							<div class="tab-pane fade px-4 py-5" id="naver" role="tabpanel" aria-labelledby="naver-tab">
								<h4 class="text-uppercase mb-3 pb-1 ">네이버 스마트스토어</h4>
								<img src="/images/naver-step1.png" class="step" />
								<p class="mb-2">1. [발주(주문)확인/발송관리] 를 클릭합니다.</p>
								<p class="mb-2">2. 조건을 입력하고 [검색] 을 클릭합니다.</p>
								<p class="mb-5">3. [엑셀다운] 버튼을 클릭합니다.</p>
								<img src="/images/naver-step2.jpeg" class="step" />
								<p class="mb-2">4. 다운로드 한 엑셀파일을 엽니다.</p>
								<p class="mb-5">5. 전체선택(Ctrl + A)을 하고 복사(Ctrl + C)를 합니다.</p>
								<img src="/images/common-step.jpeg" class="step" />
								<p class="mb-2">6. 입력란에 붙여넣기(Ctrl + V)를 합니다.</p>
								<p class="mb-2">7. [조회하기] 를 클릭합니다.</p>
								<p class="mb-2">8. 우측에 [조회결과]를 확인합니다.</p>
								<ul>
									<li class="mb-2">일치 : 녹색으로 표시</li>
									<li class="mb-2">불일치 : 적색으로 표시</li>
								</ul>
							</div>
							<div class="tab-pane fade px-4 py-5" id="coupang" role="tabpanel" aria-labelledby="coupang-tab">
								<h4 class="text-uppercase mb-3 pb-1 ">쿠팡</h4>
								<img src="/images/coupang-step1.png" class="step" />
								<p class="mb-2">1. [주문/배송 - 배송관리] 를 클릭합니다.</p>
								<p class="mb-2">2. 조건을 입력하고 [검색] 을 클릭합니다.</p>
								<p class="mb-5">3. [발주확인처리] 를 클릭합니다.</p>
								<img src="/images/coupang-step2.png" class="step" />
								<p class="mb-2">4. 다운로드 한 엑셀파일을 엽니다.</p>
								<p class="mb-5">5. 전체선택(Ctrl + A)을 하고 복사(Ctrl + C)를 합니다.</p>
								<img src="/images/common-step.jpeg" class="step" />
								<p class="mb-2">6. 입력란에 붙여넣기(Ctrl + V)를 합니다.</p>
								<p class="mb-2">7. [조회하기] 를 클릭합니다.</p>
								<p class="mb-2">8. 우측에 [조회결과]를 확인합니다.</p>
								<ul>
									<li class="mb-2">일치 : 녹색으로 표시</li>
									<li class="mb-2">불일치 : 적색으로 표시</li>
								</ul>
							</div>
							<div class="tab-pane fade px-4 py-5" id="etc" role="tabpanel" aria-labelledby="etc-tab">
								<h4 class="text-uppercase mb-3 pb-1 ">기타 오픈마켓 및 자사몰</h4>
								<p class="-2">1. 이름, 휴대전화번호, 개인통관고유부호가 포함된 엑셀파일을 엽니다.</p>
								<p class="mb-5">2. 전체선택(Ctrl + A)을 하고 복사(Ctrl + C)를 합니다.</p>
								<img src="/images/common-step.jpeg" class="step" />
								<p class="mb-2">3. 입력란에 붙여넣기(Ctrl + V)를 합니다.</p>
								<p class="mb-2">4. [조회하기] 를 클릭합니다.</p>
								<p class="mb-2">5. 우측에 [조회결과]를 확인합니다.</p>
								<ul>
									<li class="mb-2">일치 : 녹색으로 표시</li>
									<li class="mb-2">불일치 : 적색으로 표시</li>
								</ul>
							</div>
							<div class="tab-pane fade px-4 py-5" id="membership" role="tabpanel" aria-labelledby="membership-tab">
								<div class="col-lg-12">
									<h4 class="text-uppercase text-center mb-4 pb-1">멤버십 안내</h4>
									<div class="card  mt-4 rounded  border-0 shadow overflow-hidden">
										<div class="card-body" v-if="membership == '0'">
											<h5 class="text-uppercase mb-2 pb-1">무료 회원입니다.</h5>
											<p class="mb-2">멤버십에 가입하시면 더 많은 혜택을 누리실 수 있습니다.</p>
											<button class="btn btn-link paylinkfree" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
												결제내역 조회
											</button>
										</div>
										<div class="card-body" v-if="membership == '1'">
											<h5 class="text-uppercase mb-2 pb-1">{{ level }} 회원이 되어 주셔서 감사합니다.</h5>
											<p class="mb-2">최근 결제일 : {{ latest }}</p>
											<p class="mb-2">다음 결제일 : {{ next }}</p>
											<button class="btn btn-link paylink" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
												결제내역 조회
											</button>
										</div>
										<div class="card-body" v-if="membership == '2'">
											<h5 class="text-uppercase mb-2 pb-1">{{ level }} 멤버십 종료 예정 회원입니다.</h5>
											<p class="mb-2">최근 결제일 : {{ latest }}</p>
											<p class="mb-2">멤버십 종료일 : {{ next }}</p>
											<button class="btn btn-link payrefund" type="button" v-on:click="refund">
												환불하기
											</button>
											<button class="btn btn-link paylink" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
												결제내역 조회
											</button>
										</div>
									</div>

									<div class="card  mt-4 rounded  border-0 shadow overflow-hidden collapse" id="collapseExample">
										<div class="card-body">
											<h5 class="text-uppercase text-center mb-2 pb-1">결제내역</h5>
											<table class="table">
												<thead>
													<tr>
														<th scope="col" class="w-25 text-center ">결제일</th>
														<th scope="col" class="w-25 text-center ">내용</th>
														<th scope="col" class="w-25 text-center ">결제금액</th>
														<th scope="col" class="w-25 text-center ">간편결제</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="pay in paylist" v-bind:key="pay.orderDate">
														<td class="w-25 text-center ">{{ pay.orderDate }}</td>
														<td class="w-25 text-center ">{{ pay.orderName }}</td>
														<td class="w-25 text-center ">{{ pay.amount }}</td>
														<td class="w-25 text-center ">{{ pay.pg }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
								<div class="col-lg-12">
									<div class="tab-content" id="pricingpills-tabContent">
										<div class="tab-pane fade show active" id="pills-monthly" role="tabpanel" aria-labelledby="pills-monthly-tab">
											<div class="row">
												<div class="col-lg-6">
													<div class="card  mt-4 rounded text-center border-0 shadow overflow-hidden">
														<div class="card-body px-4 py-5">
															<!-- <div class="icon-mono avatar-md bg-soft-primary text-primary rounded mx-auto mb-5"><i class="icon-lg" data-feather="circle"></i></div> -->
															<div class="icon-mono avatar-md bg-soft-primary rounded mx-auto mb-5 p-3">
																<img src="../../../images/pricing/1.png" alt="" class="img-fluid d-block mx-auto" />
															</div>
															<h4 class="text-uppercase mb-4 pb-1">FREE</h4>
															<p class="text-muted">개인통관고유부호 유효성 검증</p>
															<p class="text-muted">하루 최대 조회 건수: <span class="fw-bold">100건</span></p>
															<p class="text-dark font-size-16 font-weight-semibold mb-60" v-if="membership == 0">0원 / 일</p>
															<p class="text-dark font-size-16 font-weight-semibold" v-if="membership != 0">0원 / 일</p>
															<button id="pay1" class="btn btn-soft-primary">무료</button>
														</div>
													</div>
												</div>
												<div class="col-lg-6">
													<div class="card mt-4 rounded text-center border-0 shadow overflow-hidden">
														<div class="card-body px-4 py-5">
															<span class="badge badge-primary pricing-badge shadow-lg">Most Popular</span>
															<!-- <div class="icon-mono avatar-md bg-soft-primary text-primary rounded mx-auto mb-5"><i class="icon-lg" data-feather="square"></i></div> -->
															<div class="icon-mono avatar-md bg-soft-primary rounded mx-auto mb-5 p-3">
																<img src="../../../images/pricing/2.png" alt="" class="img-fluid d-block mx-auto" />
															</div>
															<h4 class="text-uppercase mb-4 pb-1">BASIC</h4>
															<p class="text-muted">개인통관고유부호 유효성 검증</p>
															<p class="text-muted">하루 최대 조회 건수: <span class="fw-bold">무제한</span></p>
															<p class="text-dark font-size-16 font-weight-semibold">9,900원 / 30일</p>

															<p class="text-muted" v-if="membership == 0">멤버십 가입하기</p>
															<button @click="naverpay('basic')" class="border-0 p-0 btn btn-naver" v-if="email == 'myparang.io@gmail.com' && membership == 0"><img src="../../../images/pricing/npay.png" alt="" class="img-naver" /></button>
															<button @click="naverpay('good')" class="border-0 p-0 btn btn-naver" v-if="email == 'myparang.io@gmail.com' && membership == 0"><img src="../../../images/pricing/npay.png" alt="" class="img-naver" /></button>
															<button @click="naverpay('recurrent')" class="border-0 p-0 btn btn-naver" v-if="email != 'myparang.io@gmail.com' && membership == 0"><img src="../../../images/pricing/npay.png" alt="" class="img-naver" /></button>
															<button v-on:click="kakaopay" class="border-0 p-0 btn btn-kakao" v-if="membership == 0"><img src="../../../images/pricing/k1.png" alt="" class="img-kakao" /></button>
															<button v-on:click="tosspay" class="btn btn-soft-primary" v-if="membership == 0" style="padding: 9.7px;">
																<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="bi bi-credit-card" style="top: -2px; position: relative;">
																	<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"></path>
																	<path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"></path></svg
																><span style="margin: 12px 0 0 5px;font-weight: 600;font-size: 18px;">신용카드</span>
															</button>
															<button v-on:click="cancel" class="btn btn-primary" v-if="membership == 1">해지하기</button>
															<button v-on:click="rejoin" class="btn btn-primary" v-if="membership == 2">다시 가입하기</button>
														</div>
													</div>
												</div>

												<div class="col-lg-12">
													<div class="card  mt-4 rounded border-0 shadow overflow-hidden">
														<div class="card-body px-4 py-5">
															<h4 class="text-uppercase mb-3 pb-1 ">결제 가능한 신용카드 안내 (토스페이먼츠)</h4>
															<ul>
																<li class="text-muted mb-5">[신한,삼성,롯데,농협,현대,하나,BC,국민] 카드로 결제할 수 있습니다.</li>
															</ul>
															<h4 class="text-uppercase mb-3 pb-1 ">멤버십 가입(정기구독) 안내</h4>
															<ul>
																<li class="text-muted mb-2">마이파랑은 월 단위 멤버십 서비스로, 가입 후 30일이 되는 시점에 자동으로 정기 결제를 시도합니다.</li>
																<li class="text-muted mb-2">정기 결제일은 마이파랑 멤버십에 가입한 날짜로 자동 설정됩니다.</li>
																<li class="text-muted mb-2">정기 결제 실패시 멤버십 해지 상태로 전환 상태로 변경됩니다.</li>
																<li class="text-muted mb-2">정기 결제가 정상적으로 이루어지면 결제 내용을 이메일을 통해 안내 드립니다.</li>
																<li class="text-muted mb-2">정기 결제가 결제수단 등의 문제로 늦어지면, 최종적으로 결제가 이루어지는 시점 기준으로 마이파랑 시작일이 재설정됩니다.</li>
																<li class="text-muted mb-2">정기 결제는 마이파랑 최초 가입시 결제한 카드로 30일 뒤 자동결제가 이루어집니다.</li>
																<li class="text-muted mb-5">정기 결제 예정인 카드를 삭제하고 싶은 경우, 네이버톡톡 또는 채널톡으로 문의해주세요.</li>
															</ul>
															<h4 class="text-uppercase mb-3 pb-1 ">해지 안내</h4>
															<ul>
																<li class="text-muted mb-2">해지는 다음 정기 결제를 중단하는 것을 의미합니다. 즉, 해지 신청 시, 멤버십 혜택은 다음 정기 결제일까지 유지됩니다.</li>
																<li class="text-muted mb-2">해지 신청 시, 다음 정기 결제일에 결제되지 않고, 멤버십도 자동 해지됩니다.</li>
																<li class="text-muted mb-2">해지 희망시, [멤버십 안내 > 해지하기] 에서 해지 신청 가능합니다.</li>
																<li class="text-muted mb-5">해지를 요청한 시점부터 이용기간 종료일 전일까지 언제든지 해지를 철회하고 가입을 유지할 수 있습니다.</li>
															</ul>
															<h4 class="text-uppercase mb-3 pb-1 ">환불 안내</h4>
															<ul>
																<li class="text-muted mb-2">환불은 현재 이용중인 마이파랑 혜택을 즉시 반환함을 의미합니다.</li>
																<li class="text-muted mb-2">환불은 마이파랑 멤버십 가입일로부터 14일 이내 모든 멤버십 혜택을 사용하지 않은 경우에만 전액 환불됩니다.</li>
																<li class="text-muted mb-2">마이파랑 멤버십 가입일로부터 14일이 지난 경우에는 환불이 불가합니다.</li>
																<li class="text-muted mb-2">환불 희망시, 먼저 해지를 완료하고 [멤버십 안내 > 환불하기] 에서 환불 신청이 가능합니다.</li>
																<li class="text-muted mb-5">환불 완료 즉시, 모든 멤버십 혜택이 소멸됩니다.</li>
															</ul>
															<h4 class="text-uppercase mb-3 pb-1 ">서비스 탈퇴</h4>
															<ul>
																<li class="text-muted mb-2">마이파랑 멤버십을 가입한 시점부터, 마이파랑 서비스 탈퇴가 불가합니다. 해지를 신청하신 뒤 그 다음 정기결제 시점이 되면 정상적으로 멤버십이 해지되며 그때부터 탈퇴가 가능합니다.</li>
																<li class="text-muted mb-5">마이파랑 멤버십 서비스 이용 기간이 남았더라도, 자유롭게 탈퇴 할 수 있습니다. (단, 재가입 시 자동 연동이 불가하며 가입 후 수동 연동을 진행해주셔야 연동됩니다.)</li>
															</ul>
															<h4 class="text-uppercase mb-3 pb-1 ">기타 멤버십 관련 문의</h4>
															<ul>
																<li class="text-muted mb-2">네이버톡톡 또는 채널톡으로 문의해주세요.</li>
																<li class="text-muted mb-2">문의 가능 시간 : 평일 11:00~17:00</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
										<!-- end monthly tab pane -->
									</div>
									<!-- end tab content -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- end container -->
		<div id="iframe-div" class="hide">
			<iframe id="iframe-pay" v-bind:src="kakaosrc"></iframe>
		</div>
	</section>
</template>

<script>
import Swal from "../../../js/sweetalert2.min.js";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

export default {
	data() {
		return {
			ecmcount: 0,
			limit: "100건",
			ecmdata: "",
			ecmdata1: "",
			ecmdata2: "",
			ecmdata3: "",
			selInput: "option1",
			token: "",
			items: [],

			level: "",
			latest: "",
			next: "",
			email: "",
			checkSub4: "",
			changePw: "",
			membership: "",
			ecmdata: "",
			kakaosrc: "",
			paylist: [],
			local: ""
		};
	},
	beforeMount() {
		this.getMyInfo();
		axios
			.get("/ecm/count")
			.then(response => {
				Swal.close();

				if (response.status == 200) {
					var count = response.data.count;
					var membership = response.data.membership;
					this.ecmcount = count;
					if (membership == 0) {
						this.limit = "100건";
					} else {
						this.limit = "무제한";
					}
				}
			})
			.catch(error => {
				this.invalidSession(error);
			});
	},
	mounted() {
		window.addEventListener("message", function(e) {
			// kakaopay iframe close
			console.log(e.data);
			if (e.data == "closeIframe") {
				var element = document.getElementById("iframe-div");
				element.classList.add("hide");
			} else if (e.data == "kakaopaysuccess") {
				var element = document.getElementById("iframe-div");
				element.classList.add("hide");

				swal("멤버십 가입을 축하합니다.", {
					icon: "success"
				}).then(() => {
					location.reload();
				});
			} else if (e.data == "kakaopayfail") {
				var element = document.getElementById("iframe-div");
				element.classList.add("hide");

				swal("멤버십 가입이 정상적으로 처리되지 않았습니다. \n 관리자에게 문의해주세요.", {
					buttons: false,
					timer: 5000
				});
			}
		});

		if (window.location.href.includes("?")) {
			let uri = window.location.href.split("?");
			if (uri.length > 0) {
				let vars = uri[1].split("&");
				if (vars[0] == "tab=membership") {
					document.getElementById("membership-tab").click();
					window.scrollTo(0, 700);
				}
			}
		}
	},
	methods: {
		invalidSession: function(error) {
			Swal.close();
			if (error && error.response && error.response.status && error.response.status == 401) {
				swal("세션이 만료되었습니다. 다시 로그인 해주세요.").then(() => {
					this.$router.push("/signin");
				});
			} else {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
			}
		},
		tabber(e) {
			if (e.keyCode == 9) {
				var start = e.target.selectionStart;
				var textarea = this.$refs.ecmdata;
				if (e.shiftKey) {
					var tab = textarea.value.slice(start - 1, start);
					if (tab == "\t") {
						textarea.value = textarea.value.slice(0, start - 1) + textarea.value.slice(start);
						e.target.selectionStart = start - 1;
						e.target.selectionEnd = start - 1;
					}
				} else {
					textarea.value = textarea.value.slice(0, start) + "\t" + textarea.value.slice(start);
					e.target.selectionStart = start + 1;
					e.target.selectionEnd = start + 1;
				}
			}
			e.preventDefault();
			return false;
		},
		changeRadio: function() {
			console.log(this.selInput);
		},
		ecmref: function(e) {
			e.preventDefault();

			console.log("pc4");
			this.errors = [];

			if (this.selInput == "option1") {
				if (!this.ecmdata) {
					this.errors.push("내용을 입력해주세요.");
				}
			} else if (this.selInput == "option2") {
				if (!this.ecmdata1) {
					this.errors.push("개인통관고유부호를 입력해주세요.");
				}
				if (!this.ecmdata2 && !this.ecmdata3) {
					this.errors.push("이름 또는 휴대전화번호를 입력해주세요.");
				}
			} else {
				this.errors.push("잘못된 접근입니다.");
			}

			if (this.errors.length) {
				swal(this.errors[0]);
				return true;
			} else {
				var form = new FormData();
				if (this.selInput == "option1") {
					form.append("ecmdata", this.ecmdata);
				} else if (this.selInput == "option2") {
					form.append("pc4", this.ecmdata1);
					form.append("name", this.ecmdata2);
					form.append("phone", this.ecmdata3);
				}

				this.loginSuccess = false;
				Swal.showLoading();
				this.items = [];
				axios
					.post(this.local + "/ecm/ref", form)
					.then(response => {
						Swal.close();
						this.ecmdata = "";
						this.ecmdata1 = "";
						this.ecmdata2 = "";
						this.ecmdata3 = "";

						if (response.status == 200) {
							var code = response.data.code;
							var count = response.data.count;
							if (code == 10) {
								var resultList = response.data.result;
								this.ecmcount = count;
								for (var i = 0; i < resultList.length; i++) {
									var orderMember = resultList[i].orderMember;
									var orderMemberMatch = this.getMatchClass(resultList[i].orderMemberMatch);
									var orderMemberOX = this.getMatchOX(resultList[i].orderMemberMatch);
									var receiver = resultList[i].receiver;
									var receiverMatch = this.getMatchClass(resultList[i].receiverMatch);
									var receiverOX = this.getMatchOX(resultList[i].receiverMatch);

									var phoneA = resultList[i].phoneA;
									var phoneAMatch = this.getMatchClass(resultList[i].phoneAMatch);
									var phoneAOX = this.getMatchOX(resultList[i].phoneAMatch);
									var phoneB = resultList[i].phoneB;
									var phoneBMatch = this.getMatchClass(resultList[i].phoneBMatch);
									var phoneBOX = this.getMatchOX(resultList[i].phoneBMatch);

									var pcccNum = resultList[i].pcccNum;

									let item = {
										orderMember: orderMember,
										orderMemberMatch: orderMemberMatch,
										orderMemberOX: orderMemberOX,
										receiver: receiver,
										receiverMatch: receiverMatch,
										receiverOX: receiverOX,

										phoneA: phoneA,
										phoneAMatch: phoneAMatch,
										phoneAOX: phoneAOX,
										phoneB: phoneB,
										phoneBMatch: phoneBMatch,
										phoneBOX: phoneBOX,

										pcccNum: pcccNum
									};
									this.items.push(item);
								}
							} else if (code == 20) {
								swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
									this.$router.push("/signin");
								});
							} else if (code == 22) {
								swal("동일한 IP로 이미 조회한 이력이 있습니다.\n 다중계정 조회는 허용되지 않습니다.", { icon: "info" });
							} else if (code == 23) {
								swal("운영원칙 위반으로 조회가 불가능합니다.\n 궁금하신 점은 이메일 또는 채널톡으로 문의해주세요.", { icon: "info" });
							} else if (code == 24) {
								swal("현재 유니패스 서버가 불안정하여 조회되지 않고 있습니다.\n일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
							} else if (code == 30) {
								swal("내용을 입력해주세요.", { icon: "info" });
							} else if (code == 40) {
								swal("입력 양식에 맞지 않거나, 조회할 내용이 없습니다.", { icon: "info" });
							} else if (code == 100) {
								swal("하루 최대 조회 한도(100건)를 초과했습니다. \n 오늘 조회 : " + count + "건 \n 멤버십에 가입하시면 더욱 많은 조회가 가능합니다.", {
									icon: "info"
								}).then(() => {
									window.scrollTo(0, 700);
									document.getElementById("membership-tab").click();
								});
							} else {
								swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
									this.$router.push("/signin");
								});
							}
						} else {
							swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
								this.$router.push("/signin");
							});
						}
					})
					.catch(error => {
						this.invalidSession(error);
					});
			}
		},
		exceldown: function(e) {
			var data = [];
			var rows = document.querySelectorAll("table tr");

			for (var i = 0; i < rows.length; i++) {
				var row = [],
					cols = rows[i].querySelectorAll("td, th");
				for (var j = 0; j < cols.length; j++) {
					var text;
					if (j == 5 || j == 7) {
						text = '="' + cols[j].innerText + '"';
					} else {
						text = cols[j].innerText;
					}
					console.log(j + " " + text);
					row.push(text);
				}
				data.push(row.join(","));
			}

			var filename = "개인통관고유부호.csv";
			var csv_file, download_link;
			csv_file = new Blob(["\ufeff" + data.join("\n")], { type: "text/csv;charset=utf-8;" });
			download_link = document.createElement("a");
			download_link.download = filename;
			download_link.href = window.URL.createObjectURL(csv_file);
			download_link.style.display = "none";
			document.body.appendChild(download_link);
			download_link.click();
		},
		validPassword: function(password) {
			var re = /(?=.*\d)(?=.*[a-z]).{8,16}/;
			return re.test(password);
		},
		getMatchClass: function(match) {
			// -1 : 요청 전
			// 0 : 불일치
			// 1 : 일치
			// 2 : 조회 실패
			if (match == 1) {
				return "pc4-pass";
			} else if (match == 0) {
				return "pc4-fail";
			} else if (match == 3) {
				return "pc4-empty";
			} else {
				return "";
			}
		},
		getMatchOX: function(match) {
			// -1 : 요청 전
			// 0 : 불일치
			// 1 : 일치
			// 2 : 조회 실패
			if (match == 1) {
				return "o";
			} else if (match == 0) {
				return "x";
			} else {
				return "";
			}
		},

		reload: function(e) {
			console.log(e);
		},
		naverpay: function(type) {
			// 1단계
			// 1. /pay/naver 호출
			// 2. PayController 에서 paynaver.html 호출
			// 3. 결제창 열기
			// 4. /regist 콜백

			let url = window.location.origin + "/pay/nr1?orderName=" + type;
			console.log(url);
			window.location.href = url;
		},
		kakaopay: function() {
			Swal.showLoading();
			axios
				.get(this.local + "/pay/kr1")

				.then(response => {
					Swal.close();
					if (response.status == 200) {
						var msg;

						var code = response.data.code;
						if (code == 10) {
							var redirectUrl = response.data.pcUrl;
							this.kakaosrc = redirectUrl;
							var element = document.getElementById("iframe-div");
							element.classList.remove("hide");
						} else if (code == 20) {
							swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
								this.$router.push("/signin");
							});
						} else {
							swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
						}
					} else {
						swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
					}
				})
				.catch(error => {
					Swal.close();
					swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
				});
		},
		tosspay: function() {
			// 빌링
			// const clientKey = 'test_ck_N5OWRapdA8ddvl5aPbP8o1zEqZKL'
			const clientKey = "live_ck_ADpexMgkW36PwQDbqKdrGbR5ozO0";
			var customerKey = this.s4() + this.s4() + "2";
			console.log("membership tosspay" + window.location.origin);
			// customerKey 의 경우 카드등록 고객의 고유ID이며, 고객사에서 생성하시면 됩니다.
			var tossPayments = TossPayments(clientKey);
			tossPayments.requestBillingAuth("카드", {
				customerKey: customerKey,
				successUrl: window.location.origin + "/pay/tr1",
				failUrl: window.location.origin + "/pay/tr2"
				// successUrl: window.location.origin + '/main/pay/success',
				// failUrl: window.location.origin + '/main/pay/fail'
			});
		},
		getMyInfo: function(e) {
			Swal.showLoading();
			axios
				.get(this.local + "/user/userInfo")

				.then(response => {
					Swal.close();
					if (response.status == 200) {
						if (response.data.email) {
							this.email = response.data.email;
							this.membership = response.data.membership;
							this.level = response.data.level;

							if (response.data.latest) {
								this.latest = response.data.latest;
							}
							if (response.data.next) {
								this.next = response.data.next;
							}
							if (response.data.paylist) {
								this.paylist = response.data.paylist;
							}
						} else {
							swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
								this.$router.push("/signin");
							});
						}
					} else {
						swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
							this.$router.push("/signin");
						});
					}
				})
				.catch(error => {
					Swal.close();
					swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
				});
		},
		cancel: function() {
			swal({
				title: "정말로 멤버십을 해지하시겠습니까?",
				text: "해지한 이후에도 잔여기간동안 멤버십 혜택이 유지됩니다.",
				icon: "warning",
				buttons: ["아니오", "네. 해지하겠습니다."],
				dangerMode: true
			}).then(willDelete => {
				if (willDelete) {
					// 해지 절차

					this.loginSuccess = false;
					Swal.showLoading();
					axios
						.get(this.local + "/pay/c1")

						.then(response => {
							console.log(response);
							console.log(response.data);
							console.log(response.data.code);
							Swal.close();
							if (response.status == 200) {
								var msg;
								var code = response.data.code;

								if (code == 10) {
									swal("멤버십이 해지되었습니다. \n 잔여기간까지 계속 이용하실 수 있습니다.", {
										icon: "success"
									}).then(() => {
										location.reload();
									});
								} else if (code == 20) {
									swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
										this.$router.push("/signin");
									});
								} else {
									swal("멤버십이 정상적으로 해지되지 않았습니다. \n 관리자에게 문의해주세요.\n code -1", {
										icon: "success"
									}).then(() => {
										this.$router.push("/main/pc4?tab=membership");
									});
								}
							} else {
								swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
									this.$router.push("/signin");
								});
							}
						})
						.catch(error => {
							Swal.close();
						});
				}
			});
		},
		rejoin: function() {
			this.loginSuccess = false;
			Swal.showLoading();
			axios
				.post(this.local + "/pay/rejoin")

				.then(response => {
					Swal.close();
					if (response.status == 200) {
						var msg;
						var code = response.data.code;

						if (code == 10) {
							swal("다시 가입해주셔서 감사합니다.", {
								icon: "success"
							}).then(() => {
								location.reload();
							});
						} else if (code == 20) {
							swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
								this.$router.push("/signin");
							});
						} else {
							swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
						}
					} else {
						swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
					}
				})
				.catch(error => {
					Swal.close();
					swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
				});
		},
		refund: function() {
			this.loginSuccess = false;
			Swal.showLoading();
			axios
				.get(this.local + "/pay/c2")

				.then(response => {
					Swal.close();
					if (response.status == 200) {
						let message = response.data.message;
						let code = response.data.code;
						if (code == 10) {
							swal("환불처리가 완료되었습니다.", {
								icon: "success"
							}).then(() => {
								location.reload();
							});
						} else if (message) {
							console.log("message");
							swal(message, {
								icon: "info"
							}).then(() => {
								location.reload();
							});
						} else if (code == 11) {
							swal("안타깝게도 환불이 불가합니다.", "가입일로부터 14일이 지났습니다. 하단의 환불 안내를 확인해 보시고, 궁금하신 점은 네이버톡톡 또는 채널톡으로 문의해 주세요.", "info");
						} else if (code == 12) {
							swal("안타깝게도 환불이 불가합니다.", "멤버십 혜택을 사용한 이력이 있습니다. 하단의 환불 안내를 확인해 보시고, 궁금하신 점은 네이버톡톡 또는 채널톡으로 문의해 주세요.", "info");
						} else if (code == 20) {
							swal("세션이 만료되었습니다.\n다시 로그인 해주세요.").then(() => {
								this.$router.push("/signin");
							});
						} else {
							swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -1", { icon: "info" });
						}
					} else {
						swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
					}
				})
				.catch(error => {
					Swal.close();
					swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -3", { icon: "info" });
				});
		},
		s4: function() {
			return Math.random()
				.toString(36)
				.substring(2);
		},
		logout: function(e) {
			e.preventDefault();

			var form = new FormData();

			axios
				.post(this.local + "/logoutProcess")
				.then(response => {
					if (response.status == 200) {
						location.href = "/";
					} else {
					}
				})
				.catch(error => {});
		}
	}
};
</script>
<style>
.pc4-table {
	display: grid;
	grid-gap: 3px;
}

.pc4-container {
	display: grid;
	grid-template-columns: 130px 1fr 10px 1fr 10px 110px 10px 110px 10px;
	grid-gap: 3px;
}
.pf {
	width: 20px;
	height: 20px;
}
.pc4-pass {
	background-color: #e2efde;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pc4-fail {
	background-color: #ec7b7b;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pc4-empty {
	background-color: #eeeeee;
}
.pc4-pc4 {
	background-color: #eff1fc;
}
.pc4-title {
	font-weight: bold;
}
.step {
	width: 100%;
	border: 1px solid #000000;
	image-rendering: -webkit-optimize-contrast;
	transform: translateZ(0);
	backface-visibility: hidden;
	margin-bottom: 0.5rem !important;
}
.nav-item .nav-link.active {
	padding: 0.5rem 1rem;
}

.nav-item .nav-link {
	display: block;
	padding: 0.5rem 1rem 0.44rem;
	color: #0d6efd;
	text-decoration: none;
	background-color: #fff;
}

.divta1 {
	height: 200px;
	width: 150px;
}

.divta2 {
	height: 200px;
}
.divta3 {
	height: 200px;
	width: 140px;
}

.ml-5 {
	margin-left: 5px;
	position: relative;
	top: -2px;
}
.text-through {
	text-decoration: line-through;
}
.paylink {
	position: absolute;
	top: 80px;
	right: 10px;
}
.paylinkfree {
	position: absolute;
	top: 50px;
	right: 10px;
}
.payrefund {
	position: absolute;
	top: 80px;
	right: 150px;
	padding: 12px 0;
}

.btn-kakao {
	width: 100px;
	height: 48.5px;
	border-radius: 3px;
	background-color: #ffeb00;
}

.img-kakao {
	background-color: #ffeb00;
	width: 72.75px;
	height: 30px;
}

.img-naver {
	height: 48.5px;
}

.btn-toss {
	width: 100px;
	height: 48.5px;
	border-radius: 3px;
}

.img-toss {
	width: 72px;
	height: 24px;
}

.mb-60 {
	margin-bottom: 60px;
}

#iframe-div {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0px;
	z-index: 9999999;
	transform: translateZ(0px);
	background-color: rgba(0, 0, 0, 0.6);
	margin: 0px;
	padding: 0px;
}

#iframe-pay {
	border: none;
	position: absolute;
	top: 50%;
	left: 50%;
	width: 650px;
	height: 650px;
	margin-left: -325px;
	margin-top: -325px;
	background-color: rgb(255, 255, 255);
}

.hide {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Pc4.vue